module.exports = __webpack_public_path__ + "img/SainaPlayPoster.6ffdafcd.png";